import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd79ae70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "filterbar",
  "data-role": "droptarget"
}
const _hoisted_2 = {
  class: "row",
  style: {"padding-right":"17px"}
}
const _hoisted_3 = { class: "col-sm-4" }
const _hoisted_4 = {
  class: "filter-button",
  id: "dashboard-filters"
}
const _hoisted_5 = {
  id: "filters-dashboard",
  class: "dropdown"
}
const _hoisted_6 = {
  key: 0,
  href: "#",
  class: "modaltoolbarIcon neu-tooltip",
  style: {"cursor":"pointer","color":"#3673AA"},
  onclick: "window.open('https://mediaconnect.app.medcity.net/embed?id=7c99a26f-7a09-4672-aa72-e7c6c50911f6', '', 'addressbar=false,toolbar=false,width=900,height=600,left=200,top=200,resizable=yes,title=Learn How')"
}
const _hoisted_7 = { "aria-hidden": "true" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, [
  /*#__PURE__*/_createTextVNode("Click to learn how"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("to print Daily Roster")
], -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 2,
  class: "clPendingConfirmationWrapper"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  class: "badge bg-danger",
  id: "clPendingConfirmationCount"
}
const _hoisted_13 = { class: "col-sm-2 p-0" }
const _hoisted_14 = {
  class: "row",
  id: "labelsform-dashboard-container"
}
const _hoisted_15 = { class: "col-md-8" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  id: "currentShiftLabel-dashboard-label"
}, "From:", -1))
const _hoisted_18 = {
  id: "currentShiftLabel-dashboard",
  name: "currentShiftLabel-dashboard"
}
const _hoisted_19 = { class: "form-group mt-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label",
  id: "nextShiftLabel-dashboard-label"
}, "To:", -1))
const _hoisted_21 = {
  id: "nextShiftLabel-dashboard",
  name: "nextShiftLabel-dashboard"
}
const _hoisted_22 = {
  id: "divCalloutPopup",
  class: "col-sm-6 text-start pl-0 pr-0"
}
const _hoisted_23 = {
  class: "badge bg-success",
  id: "divContractLoborCount"
}
const _hoisted_24 = {
  class: "badge bg-warning",
  id: "divCalloutCount"
}
const _hoisted_25 = {
  id: "actionsBtn",
  class: "pt-2 actionBtn"
}
const _hoisted_26 = { "aria-hidden": "true" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Export to PDF", -1))
const _hoisted_28 = { "aria-hidden": "true" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Export to Excel", -1))
const _hoisted_30 = { "aria-hidden": "true" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Refresh Screen", -1))
const _hoisted_32 = { href: "#" }
const _hoisted_33 = { class: "toggle" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "disableRefreshToggle-dashboard",
  class: "neu-tooltip",
  style: {"width":"40px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "toggle-button" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "toggle-tab" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text tooltipTxt" }, "Click here to disable auto refresh")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainViewFilter = _resolveComponent("MainViewFilter")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_icon = _resolveComponent("neu-icon")!
  const _component_DashboardNavbar = _resolveComponent("DashboardNavbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btn btn-primary dropdown-toggle",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showFilter && _ctx.showFilter(...args))),
              "data-bs-toggle": "dropdown",
              id: "filters-dashboard-button",
              "aria-haspopup": "true",
              "aria-expanded": "false",
              role: "button"
            }, "Filters"),
            _createElementVNode("div", {
              class: _normalizeClass(["dropdown-menu", [_ctx.isShowFilterDropdown ? 'filterShow': '' , 'dropdown-menu']])
            }, [
              _createVNode(_component_MainViewFilter, {
                dashboardConfig: _ctx.dashboardConfig,
                filterPreferences: _ctx.filterPreferences
              }, null, 8, ["dashboardConfig", "filterPreferences"])
            ], 2),
            (_ctx.profileData.TrainingEnabled)
              ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'fa-video'],
                      size: "lg"
                    }),
                    _createTextVNode(" Learn How ")
                  ]),
                  _hoisted_8
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.filterPreferenceDetails != null)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              name: "ddlfilterPreference",
              "data-role": "dropdownlist",
              class: "neu-select filterSelect",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFilterPreference) = $event)),
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChangeFilterPreference && _ctx.onChangeFilterPreference(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterPreferenceDetails, (fpd) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: fpd.id,
                  key: fpd.id
                }, _toDisplayString(fpd.name), 9, _hoisted_9))
              }), 128))
            ], 544)), [
              [_vModelSelect, _ctx.selectedFilterPreference]
            ])
          : _createCommentVNode("", true),
        (_ctx.filterPreferenceDetails != null)
          ? (_openBlock(), _createBlock(_component_neu_icon, {
              key: 1,
              class: "material-icons neu-input__select-icon z-max"
            }, {
              default: _withCtx(() => [
                _createTextVNode("arrow_drop_down")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isCLPendingConfirmationBtnVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("a", {
                class: "btn btn-light ms-3 clPendingConfirmationBtn",
                href: _ctx.clPendingConfirmationBtnURL,
                target: "_blank"
              }, [
                _createTextVNode(" CL Pending Confirmations "),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.CLPendingCount), 1)
              ], 8, _hoisted_11)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.startDateTimeTxt), 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.endDateTimeTxt), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-light me-2 calloutBtn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showContractLaborPopup()))
        }, [
          _createTextVNode(" Contract Labor "),
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.contractLoborCountTxt), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-light calloutBtn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showCalloutPopup()))
        }, [
          _createTextVNode(" Call Out "),
          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.calloutCountTxt), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_DashboardNavbar),
          _createElementVNode("a", {
            href: "#",
            class: "modaltoolbarIcon neu-tooltip",
            style: {"cursor":"pointer"},
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.printDashbaordGrid && _ctx.printDashbaordGrid(...args)))
          }, [
            _createElementVNode("i", _hoisted_26, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'file-pdf'],
                size: "lg"
              })
            ]),
            _hoisted_27
          ]),
          _createElementVNode("a", {
            href: "#",
            class: "modaltoolbarIcon neu-tooltip",
            style: {"cursor":"pointer"},
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.printDashbaordGridToExcel && _ctx.printDashbaordGridToExcel(...args)))
          }, [
            _createElementVNode("i", _hoisted_28, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'file-excel'],
                size: "lg"
              })
            ]),
            _hoisted_29
          ]),
          _createElementVNode("a", {
            href: "#",
            class: "modaltoolbarIcon neu-tooltip",
            style: {"cursor":"pointer"},
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.refreshDashboard()))
          }, [
            _createElementVNode("i", _hoisted_30, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'sync'],
                size: "lg"
              })
            ]),
            _hoisted_31
          ]),
          _createElementVNode("a", _hoisted_32, [
            _createElementVNode("fieldset", _hoisted_33, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "cmn-toggle cmn-toggle-round",
                id: "disableRefreshToggle-dashboard",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isEnableAutoRefresh) = $event)),
                onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onChangesAutoRefresh && _ctx.onChangesAutoRefresh(...args)))
              }, null, 544), [
                [_vModelCheckbox, _ctx.isEnableAutoRefresh]
              ]),
              _hoisted_34
            ])
          ])
        ])
      ])
    ])
  ]))
}